import { render, staticRenderFns } from "./weeklyCp.vue?vue&type=template&id=0ea10bae"
import script from "./weeklyCp.vue?vue&type=script&lang=js"
export * from "./weeklyCp.vue?vue&type=script&lang=js"
import style0 from "./weeklyCp.vue?vue&type=style&index=0&id=0ea10bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports